import { Paragraph } from '@audio-network/componentlibrary'
import styles from './Toast.module.css'

const ToastBody = ({
	children,
	...props
}: {
	children: React.ReactNode
}): JSX.Element => {
	return (
		<Paragraph className={styles.toastBody} {...props}>
			{children}
		</Paragraph>
	)
}

export default ToastBody
